import HttpService from '@/services/HttpService';
import { error } from '@/utils/error';
const getProductsByQueryString = async ({ Propositie, Basis, Combi, Aanvullend, Tand, EigenRisico }) => {
    const path = '/clientcontroller/prefillclient/ophalenproductenbijquerystring';
    const payload = {
        Propositie,
        Basis,
        Combi,
        Aanvullend,
        Tand,
        EigenRisico
    };
    const { data } = (await HttpService.post(path, payload));
    if (!data) {
        error('Client controller call was unsuccessful', {
            path,
            payload: JSON.stringify(payload)
        });
    }
    return data;
};
const getPrefillData = async (affiliateKey) => {
    const path = `/clientcontroller/prefillclient/prefilldata?prefillDataKey=${affiliateKey}`;
    const { data } = (await HttpService.get(path));
    if (!data) {
        error('Client controller call was unsuccessful', {
            path
        });
    }
    return data;
};
export default {
    getProductsByQueryString,
    getPrefillData
};
